module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zM3 2.9v18h21v-18H3zm14.6 4H8.8l-2.6-2h14.1l-2.7 2zm-.6 2v6h-7v-6h7zm-9 .6v5.6l-3 2.6V7l3 2.5zm1.6 7.4h8.2l2.6 2H6.9l2.7-2zm9.4-1.8V8.8l3-2.6v11.4l-3-2.5z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/assign_thermalzone.svg
// module id = 699
// module chunks = 2